<template>
  <div class="p-0">
    <!--Botones de Confirmación y Edición-->
    <!-- <div class="row">
      <div class="col-1">
        <div class="d-flex justify-content-end m-2">
          <b-button
            variant="info"
            size="sm"
            @click="
              showEdition == true ? (showEdition = false) : (showEdition = true)
            "
          >
            <span v-if="showEdition">Terminar Edición</span>
            <span v-else>Editar</span>
          </b-button>
        </div>
      </div>
    </div>-->

    <div class="row m-2">
      <b-dropdown
        :class="{ ocultarClass: esHome }"
        id="dropdown-1"
        size="sm"
        variant="info "
        text="Editar"
        right
        class="btn-elemento btn-options justify-self-center"
      >
        <b-dropdown-item
          @click="
            showEdition == true ? (showEdition = false) : (showEdition = true)
          "
        >
          <span v-if="showEdition">Terminar Edición</span>
          <span v-else>Editar Texto</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="
            showAnimation == true
              ? (showAnimation = false)
              : (showAnimation = true)
          "
        >Agregar animación</b-dropdown-item>
        <b-dropdown-item
          @click="
            showMargin == true ? (showMargin = false) : (showMargin = true)
          "
        >Agregar margen</b-dropdown-item>
      </b-dropdown>
    </div>

    <div v-show="showPosition" class="row pb-2">
      <div class="col-12 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Posicionar</p>
        </div>
        <div class="p-3">
          <b-button-group size="sm" class="d-flex flex-row justify-content-center">
            <b-button @click="changePosition('left')" class="mx-4" active variant="outline-success">
              <img src="@/assets/f-left.svg" alt />
            </b-button>
            <b-button @click="changePosition('center')" class="mx-4" variant="outline-info">
              <img src="@/assets/f-center.svg" alt />
            </b-button>
            <b-button @click="changePosition('right')" class="mx-4" variant="outline-warning">
              <img src="@/assets/f-right.svg" alt />
            </b-button>
          </b-button-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button size="sm" v-on:click="showPosition = false" variant="success">Guardar</b-button>
        </div>
      </div>
    </div>

    <div v-show="showAnimation" class="row">
      <div class="col-12 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="setAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >FadeIn</div>
            <div style="overflow:hidden ">
              <div
                @click="setAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >Bounce</div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="setAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >Slide in</div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="setAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >Slide in</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="saveAnimation()" class="p-2" variant="success">Guardar</b-button>
          </div>
        </div>
      </div>
    </div>
    <!--NOTE menu margen-->
    <div v-show="showMargin" class="row">
      <div class="col-8 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar Márgenes</p>
          <!--<p
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            " 
            class="btn btn-warning mx-2 my-1"
          >Cerrar</p>-->
        </div>

        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div style="overflow:hidden ">
              <label for="left">Margen izquierdo</label>
              <input
                v-model.number="localMargin['ml']"
                type="number"
                min="0"
                max="8"
                name="left"
                id
              />
            </div>

            <div style="overflow:hidden ">
              <label for="top">Margen superior</label>
              <input v-model.number="localMargin['mt']" type="number" min="0" max="8" name="top" id />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <label for="right">Margen derecho</label>
              <input
                v-model.number="localMargin['mr']"
                type="number"
                min="0"
                max="8"
                name="right"
                id
              />
            </div>
            <div style="overflow:hidden">
              <label for="bottom">Margen inferior</label>
              <input v-model.number="localMargin['mb']" type="number" min="0" max="8" name="bottom" />
            </div>
          </div>
        </div>
        <div class="col">
          <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

          <div
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
            class="btn btn-danger m-2"
          >Cerrar</div>
        </div>
      </div>
    </div>

    <div class="row d-flex mx-1 p-0">
      <div class="container p-0 m-0">
        <div class="row p-0 m-0">
          <div class="col-12 p-0">
            <!--Botones de Confirmación y Edición-->
            <div class="d-flex">
              <div v-show="showEdition">
                <div class="d-flex justify-content-end m-2">
                  <b-button
                    size="sm"
                    variant="success"
                    @click="handleSavingContent"
                    class="btn btn-success mb-2 p-2"
                  >Guardar</b-button>
                </div>
                <vue-editor v-model="content" :editor-toolbar="customToolbar"></vue-editor>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div ref="textelement" class="text-elem">
              <!-- <div  > -->
              <div ref="htmlelement" v-show="!showEdition" v-html="content" class="p-0"></div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="tooltip" class="container" ref="tooltip">
      <div class="row">
        <div class="col-12">
          <p class="h3">
            Margenes
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <p class="h5">Left</p>
        </div>
        <div class="col-6">
          <p class="h5">Top</p>
        </div>
        <div class="col-6">
          <p class="h5">Right</p>
        </div>
        <div class="col-6">
          <p class="h5">Bottom</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },

  props: {
    index: Number,
    data: Object,
    idSection: String,
    subid: Number,
    route: Object,
    esHome: Boolean,
    elementid: Number
  },

  data() {
    return {
      content: '',
      showEdition: false,
      localRoot: '',
      textoJSON: 'null',
      // Modales y botones
      subirImg: false,
      showAnimation: false,
      showPosition: false,
      animation: '',
      position: '',
      isElem: true,
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ color: [] }, { background: [] }],
        ['bold', 'italic', 'underline'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote']
      ],
      showMargin: false,
      limit: 5,
      minimum: 0,
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },

  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    if (this.route != null) {
      this.content = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['src']
      this.animation = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['animation']
      this.position = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['position']
      this.localMargin = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['margin']
      this.localPadding = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['padding']

      this.isElem = false
    } else {
      this.content = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].src[0]['name']

      this.animation = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].animation[0]
      this.localMargin = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
      this.localPadding = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']
      this.isElem = true
    }
    // console.log(this.content)
  },

  mounted() {
    this.setAnimation(this.animation)
    this.changePosition(this.position)
    let textElementMargin = this.$refs.textelement

    textElementMargin.classList.add(
      'pt-' + this.localPadding['pt'],
      'mt-' + this.localMargin['mt']
    )
    textElementMargin.classList.add(
      'pr-' + this.localPadding['pr'],
      'mr-' + this.localMargin['mr']
    )
    textElementMargin.classList.add(
      'pb-' + this.localPadding['pb'],
      'mb-' + this.localMargin['mb']
    )
    textElementMargin.classList.add(
      'pl-' + this.localPadding['pl'],
      'ml-' + this.localMargin['ml']
    )
  },

  methods: {
    changePosition(value) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.position = ''
      switch (value) {
        case 'left':
          this.$refs.textelement.classList.remove('justify-content-end')
          this.$refs.textelement.classList.remove('justify-content-center')
          this.$refs.textelement.classList.add('justify-content-start')
          this.position = 'left'
          break
        case 'center':
          this.$refs.textelement.classList.remove('justify-content-start')
          this.$refs.textelement.classList.remove('justify-content-end')
          this.$refs.textelement.classList.add('justify-content-center')
          this.position = 'center'
          break
        case 'right':
          this.$refs.textelement.classList.remove('justify-content-start')
          this.$refs.textelement.classList.remove('justify-content-center')
          this.$refs.textelement.classList.add('justify-content-end')
          this.position = 'right'
          break

        default:
          break
      }

      //Se guarda la posición del elemento en root
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['position'] = this.position
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'position'
        ] = this.position
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },

    addMargin() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let textElementMargin = this.$refs.textelement
      if (textElementMargin === undefined) {
        return
      }
      textElementMargin.className = ''

      //textElementMargin.classList.add('d-flex', 'text-elem')

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin

        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'margin'
        ] = this.localMargin
        this.localRoot['componentes'][this.route.name][this.route.index][
          'padding'
        ] = this.localMargin
      }

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    handleSavingContent: function() {
      // Esta funcion guarda el contenido del editor dentro del JSON root
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid].elements[this.elementid].src[0].name = this.content
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'src'
        ] = this.content
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      console.log(this.content)
    },
    setAnimation(type) {
      this.animation = ''
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (type) {
        case 'rl':
          this.animation = 'rl'
          break

        case 'lr':
          this.animation = 'lr'
          break
        case 'bounce':
          this.animation = 'bounce'
          break
        case 'fade':
          this.animation = 'fade'
          break
        default:
          break
      }
    },
    saveAnimation() {
      this.showAnimation = false
      this.textoJSON.animation = this.animation
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100% !important;
}
.btn-elemento {
  position: absolute;
  top: -20px;
  right: 0;
  margin: 5px;
}

.text-elem {
  /*height: 200px;
  width: 400px;*/
  position: relative;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}
.base-animation {
  opacity: 1;
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}

@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}
</style>
